import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import { logout } from '../../../../api'
import { LOCAL_STORAGE_NAME_TOKEN } from '../../../../constants/storage'
import { useInitActions, useInitData } from '../../../../hooks'
import { destroyProductFruits } from '../../../../utils/productFruits'
import { removeStorageItem } from '../../../../utils/storage'

export function useAuthValidateHash({ onValidate }) {
  const { authorized } = useInitData()

  const [loading, setLoading] = useState(true)
  const [isValidHash, setValidHash] = useState(false)

  const { resetApp } = useInitActions()

  const { hash } = useParams()

  useEffect(() => {
    async function validate() {
      setLoading(true)

      function cleanUserLocalData() {
        removeStorageItem(LOCAL_STORAGE_NAME_TOKEN)
        resetApp()
      }

      if (authorized) {
        try {
          await logout()
        } catch (error) {
          console.warn('Logout failed:', error)
        } finally {
          destroyProductFruits()
          cleanUserLocalData()
        }
      }

      try {
        const data = await onValidate(hash)

        setValidHash(!data?.error)
      } catch (error) {
        console.warn('Hash invalid:', error)
        setValidHash(false)
      } finally {
        setLoading(false)
      }
    }

    validate()
  }, [hash])

  return {
    isValidHash,
    loading,
  }
}
